module.exports = __webpack_public_path__ + "img/grayscale-JLL.03c517ef.png";